/*!
 * Order consultation in the text on the blog page
 */

/* globals inputmask */
/* globals grecaptcha */
import {submitHandler} from '../utils/submit-handler';
import {showResult} from '../utils/response-notice';
import messages from '../messages/common';

const message = messages();
const wrap = '.professional-consultancy';

/**
 * Validate and send form
 */
let initValidate = ($wrapElem) => {
    $wrapElem.find('form').validate({
        focusCleanup: true,
        rules: {
            'consultation[name]': {
                required: true,
                minlength: 2,
                normalizer: (value) => {
                    return $.trim(value);
                },
            },
            'consultation[email]': {
                required: true,
                email: true,
            },
            'consultation[phone]': {
                required: true,
                minlength: 11,
                normalizer: (value) => {
                    return $.trim(value);
                },
            },
            'consultation[question]': {
                required: true,
                minlength: 5,
                normalizer: (value) => {
                    return $.trim(value);
                },
            },
        },
        messages: {
            'consultation[name]': {
                required: 'Заполните, пожалуйста, данные.',
                minlength: 'Имя должно быть не меньше 2-х символов!',
            },
            'consultation[email]': {
                required: 'Заполните, пожалуйста, данные.',
                email: 'Неправильный E-mail',
            },
            'consultation[phone]': {
                required: 'Заполните, пожалуйста, данные.',
                minlength: 'Телефон должен быть не меньше 11-ти символов!',
            },
            'consultation[question]': {
                required: 'Заполните, пожалуйста, данные.',
                minlength: 'Вопрос должен быть не менее 5-ти символов!',
            },
        },
        submitHandler() {
            let $form = $wrapElem.find('form');

            submitHandler($form).then((json) => {
                showResult($form, json, {
                    title: message.thanks,
                    body: message.textRequest,
                });
            });
        },
        errorClass: 'invalid',
        errorPlacement(error, Element) {
            error.addClass('error');
            error.wrapInner($('<div>').addClass('error-inner'));
            Element.after(error);
        },
    });
};

/**
 * Init recaptcha
 * @param $wrapElem
 */
let initReCaptcha = ($wrapElem) => {
    let key = $wrapElem.eq(0).data('captcha');

    grecaptcha.ready(() => {
        grecaptcha.execute(key, {action: 'homepage'}).then((token) => {
            $(`${wrap} input[name=recaptcha_consultation]`).val(token);
        });
    });
};

/**
 * Init list
 */
let init = () => {
    let $wrapElem = $(wrap);

    if (!$wrapElem.length) {
        return;
    }

    $wrapElem.each((i, elem) => {
        initValidate($(elem));
    });

    inputmask('+79999999999').mask('.inputmask-phone');
    initReCaptcha($wrapElem);

    $(`${wrap} input[name="consultation[page_url]"]`).val(window.location.href);
};

export {init as initProfessionalConsultancy};
